/*
    Store modules
 */
const MODULES = {
  APP: "AppModule",
  PAYMENT: "PaymentModule",
  WELCOME: "WelcomeModule",
  COUNTRY: "CountryModule",
  USER: "UserModule",
  PLAN: "PlanModule",
  ANXIETY: "AnxietyModule",
};

export { MODULES };
